import { Option } from '@beeline/design-system-react/extracted-styles';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { startAppListening } from '../listenerMiddleware';

import { emptyPermissions, initialState } from './initialState';
import { fetchEmployeePermissions, saveEmployeePermissions } from './services';

export const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setEmployee: (state, action: PayloadAction<Option<string> | null>) => {
      state.employee = action.payload;
    },
    setPermission: (
      state,
      action: PayloadAction<{ id: number; enabled: boolean }>,
    ) => {
      state.permissions = state.permissions.map(permission =>
        permission.permissionId === action.payload.id
          ? {
              ...permission,
              enabled: action.payload.enabled,
            }
          : permission,
      );
    },
    clearPermissions: state => {
      state.employee = null;
      state.permissions = emptyPermissions;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchEmployeePermissions.pending, state => {
      state.error = undefined;
      state.loading = true;
    });
    builder.addCase(fetchEmployeePermissions.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchEmployeePermissions.fulfilled, (state, action) => {
      state.loading = false;
      state.permissions = action.payload.permissions;
    });

    builder.addCase(saveEmployeePermissions.fulfilled, state => {
      state.employee = null;
      state.permissions = emptyPermissions;
    });
  },
});

export const { actions: permissionsActions, reducer: permissionsReducer } =
  permissionsSlice;

startAppListening({
  predicate: (action, current, previous) => {
    return (
      current.sidesheet.current !== 'permissions' &&
      previous.sidesheet.current === 'permissions'
    );
  },
  effect: (action, listenerApi) => {
    listenerApi.dispatch(permissionsActions.clearPermissions());
  },
});
